/**
 * Law firm autocomplete empty-state copy (flatten nested ternary in Register form).
 */
export function getLawFirmNoOptionsText(lawFirmSearch, filteredLawFirmsLength) {
  if (lawFirmSearch.length > 0 && lawFirmSearch.length < 3) {
    return "Type at least 3 characters to search";
  }
  if (filteredLawFirmsLength === 0 && lawFirmSearch.length >= 3) {
    return "No law firms found";
  }
  return "Start typing to search law firms";
}
